import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Workspace from '../views/Workspace.vue';
import Changelog from '../views/Changelog.vue';
import Login from '../views/Login.vue';
import CompositeViewer from '../views/CompositeViewer.vue';
import { useAuthStore } from '../stores/auth.store';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/changelog',
      name: 'changelog',
      component: Changelog,
    },
    {
      path: '/workspace',
      name: 'workspace',
      component: Workspace,
    },
    {
      path: '/workspace/:hypothesisId?',
      name: 'workspace-hypothesis',
      component: Workspace,
    },
    {
      path: '/blocs/:id/composite',
      name: 'bloc-composite',
      component: CompositeViewer,
    },
  ],
});

router.beforeEach(async (to, _from, next) => {
  if (to.name === 'login') {
    next();
    return;
  }
  const authStore = useAuthStore();
  const required = await authStore.fetchStatus();
  if (required && !authStore.isAuthenticated) {
    next({ name: 'login', query: { redirect: to.fullPath } });
    return;
  }
  next();
});

export default router;
